import { create } from "zustand"
import { persist } from "zustand/middleware"
import { useItemFilterStore } from "../../items/stores/item-filter-store"

// Sync the items tab filter whenever showOnlyMyItems changes
function syncItemFilter(value: boolean) {
  useItemFilterStore.getState().setShowMyItems(value)
}

interface MatterPreferencesState {
  // Server-backed setting — initialized from user.matter_settings on app load
  showOnlyMyItems: boolean
  setShowOnlyMyItems: (value: boolean) => void
  toggleShowOnlyMyItems: () => void

  // Local-only UI preference
  bannerCollapsed: boolean
  setBannerCollapsed: (value: boolean) => void
  toggleBannerCollapsed: () => void

  // Set from server setting on app load
  initFromServerSetting: (value: boolean) => void
}

const initialState = {
  showOnlyMyItems: false,
  bannerCollapsed: false,
}

export const useMatterPreferencesStore = create<MatterPreferencesState>()(
  persist(
    (set, get) => ({
      ...initialState,
      setShowOnlyMyItems: (value) => {
        set({ showOnlyMyItems: value })
        syncItemFilter(value)
      },
      toggleShowOnlyMyItems: () => {
        const next = !get().showOnlyMyItems
        set({ showOnlyMyItems: next })
        syncItemFilter(next)
      },
      setBannerCollapsed: (value) => set({ bannerCollapsed: value }),
      toggleBannerCollapsed: () => set((s) => ({ bannerCollapsed: !s.bannerCollapsed })),
      initFromServerSetting: (value) => {
        set({ showOnlyMyItems: value })
        syncItemFilter(value)
      },
    }),
    {
      name: "archk-matter-preferences",
      // Only persist bannerCollapsed — showOnlyMyItems comes from server
      partialize: (state) => ({
        bannerCollapsed: state.bannerCollapsed,
      }),
    }
  )
)
